import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AppComponent } from './../app/app.component';
import { TableServiceComponent } from './table-service/table-service.component';
import { RegisterServicesComponent } from './register-services/register-services.component';
import { AuthGuard } from './common/services/auth-guard.service';
import { HqAccessGuardService } from './common/guards/hq-access-guard.service';
import { TableRouteGuard } from './tables-layout/table-route.guard';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'orders',
    pathMatch: 'full',
  },
  {
    path: 'tableservice',
    component: TableServiceComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'table-bookings',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./table-bookings/table-bookings.module').then(
        (mod) => mod.TableBookingsModule
      ),
  },
  {
    path: 'ai-insights',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./ai-insights/ai-insights.module').then(
        (mod) => mod.AiInsightsModule
      ),
  },
  {
    path: 'section-counters',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./section-counter/section-counter.module').then(
        (mod) => mod.SectionCounterModule
      ),
  },
  {
    path: 'menu',
    canActivate: [AuthGuard, HqAccessGuardService],
    loadChildren: () =>
      import('./menudishes/menudishes.module').then(
        (mod) => mod.MenudishesModule
      ),
  },
  {
    path: 'menudishes',
    canActivate: [AuthGuard, HqAccessGuardService],
    loadChildren: () =>
      import('./menudishes/menudishes.module').then(
        (mod) => mod.MenudishesModule
      ),
  },
  {
    path: 'login',
    loadChildren: () =>
      import('./login/login.module').then((mod) => mod.LoginModule),
  },
   {
    path: 'order-status',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./order-status/order-status.module').then((mod) => mod.OrderStatusModule),
  },
  { path: 'root', component: AppComponent, canActivate: [AuthGuard] },
  {
    path: 'register-services',
    component: RegisterServicesComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'pending-payment',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import(
        './collection-infrastructure/collection-infrastructure.module'
      ).then((mod) => mod.CollectionInfrastructureModule),
  },
  {
    path: 'restaurant',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./restaurant/restaurant.module').then(
        (mod) => mod.RestaurantModule
      ),
  },
  {
    path: 'reports',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./invoice/invoice.module').then((mod) => mod.InvoiceModule),
  },
  {
    path: 'pos',
    canActivate: [AuthGuard, HqAccessGuardService],
    loadChildren: () =>
      import('./pos-order/pos-order.module').then((mod) => mod.PosOrderModule),
  },
  {
    path: 'pos-mobile',
    canActivate: [AuthGuard, HqAccessGuardService],
    loadChildren: () =>
      import('./pos-mobile/pos-mobile.module').then(
        (mod) => mod.PosMobileModule
      ),
  },
  {
    path: 'orders',
    canActivate: [AuthGuard, HqAccessGuardService],
    loadChildren: () =>
      import('./order/order.module').then((mod) => mod.OrderModule),
  },
  {
    path: 'tables',
    canActivate: [AuthGuard, TableRouteGuard],
    loadChildren: () =>
      import('./tables-layout/tables-layout.module').then(
        (m) => m.TablesLayoutModule
      ),
  },
  {
    path: 'inventory',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./inventory/inventory.module').then((mod) => mod.InventoryModule),
  },
  {
    path: 'analytics',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./restaurant-analytics/restaurant-analytics.module').then(
        (mod) => mod.RestaurantAnalyticsModule
      ),
  },
  {
    path: 'settlement',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./settlement/settlement.module').then(
        (mod) => mod.SettlementModule
      ),
  },
  {
    path: 'help-center',
    loadChildren: () =>
      import('./help-center/help-center.module').then(
        (m) => m.HelpCenterModule
      ),
  },

  /*
    existing modules are modified to HQ routes
  */
  {
    path: 'hq/login',
    loadChildren: () =>
      import('./login/login.module').then((mod) => mod.LoginModule),
  },
  {
    path: 'hq/outlets',
    loadChildren: () =>
      import('./hq-outlets/hq-outlets.module').then((m) => m.HqOutletsModule),
  },
  {
    path: 'hq/billing',

    loadChildren: () =>
      import('./billing/billing.module').then((m) => m.BillingModule),
  },
  {
    path: 'hq/dashboard',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./hq-easyeat/hq-easyeat.module').then((m) => m.HqEasyeatModule),
  },
  {
    path: 'hq/discounts',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./discounts/discounts.module').then((m) => m.DiscountsModule),
  },
  {
    path: 'hq/staff-center',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./staff-center/staff-center.module').then(
        (m) => m.StaffCenterModule
      ),
  },
  {
    path: 'hq/inventory',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./inventory/inventory.module').then((mod) => mod.InventoryModule),
  },
  {
    path: 'hq/analytics',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./restaurant-analytics/restaurant-analytics.module').then(
        (mod) => mod.RestaurantAnalyticsModule
      ),
  },
  {
    path: 'hq/settlement',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./settlement/settlement.module').then(
        (mod) => mod.SettlementModule
      ),
  },
  {
    path: 'hq/reports',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./invoice/invoice.module').then((mod) => mod.InvoiceModule),
  },
  {
    path: 'hq/loyaltyProgram',
    loadChildren: () =>
      import('./loyalty-program/loyaltyProgram.module').then(
        (mod) => mod.LoyaltyProgramModule
      ),
  },
  {
    path: 'hq/referralProgram',
    loadChildren: () =>
      import('./referral-program/referralProgram.module').then(
        (mod) => mod.ReferralProgramModule
      ),
  },
  {
    path: 'hq/marketing',
    loadChildren: () =>
      import('./marketing/marketing.module').then((mod) => mod.MarketingModule),
  },
  {
    path: 'hq/restaurant',
    loadChildren: () =>
      import('./restaurant/restaurant.module').then(
        (mod) => mod.RestaurantModule
      ),
  },
  {
    path: 'discounts',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./discounts/discounts.module').then((m) => m.DiscountsModule),
  },
  {
    path: 'staff-center',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./staff-center/staff-center.module').then(
        (m) => m.StaffCenterModule
      ),
  },
  {
    path: 'hq/e-invoice',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./e-invoice/e-invoice.module').then(
        (m) => m.EInvoiceModule
      ),
  },
  {
    path: 'lock',
    loadChildren: () => import('./lock/lock.module').then((m) => m.LockModule),
  },
  {
    path: 'hq/no-permission',
    loadChildren: () =>
      import('./no-permission/no-permission.module').then(
        (m) => m.NoPermissionModule
      ),
  },
  {
    path: 'hq/pending-orders',
    loadChildren: () =>
      import('./pending-orders/pending-orders.module').then(
        (m) => m.PendingOrdersModule
      ),
  },
  {
    path: 'hq/help-center',
    loadChildren: () =>
      import('./help-center/help-center.module').then(
        (m) => m.HelpCenterModule
      ),
  },
  {
    path: 'hq/menu-management',
    loadChildren: () =>
      import('./central-menu-management/central-menu-management.module').then(
        (m) => m.CentralMenuManagementModule
      ),
  },
  {
    path: 'hq/integrations',
    loadChildren: () =>
      import('./integrations/integrations.module').then(
        (m) => m.IntegrationsModule
      ),
  },
  {
    path: 'hq/customer-display',
    loadChildren: () =>
      import('./customer-display/customer-display.module').then(
        (m) => m.CustomerDisplayModule
      ),
  },
  {
    path: 'hq/restaurant-setting',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./other-tool/other-tool.module').then((m) => m.OtherToolModule),
  },
  {
    path: 'hq/device-center',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./other-tool/device-center/device-center.module').then(
        (m) => m.DeviceCenterModule
      ),
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}

export const RoutingComponent = [AppComponent];
